import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent
} from '@mui/material';
import { Package, PackageType } from '../../../types/Venue';

interface PackageBasicInfoFormProps {
  packageData: Partial<Package>;
  onChange: (data: Partial<Package>) => void;
}

const PackageBasicInfoForm: React.FC<PackageBasicInfoFormProps> = ({ 
  packageData, 
  onChange 
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const handleSelectChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    onChange({ [name as string]: value as PackageType });
  };

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Basic Package Information
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            id="name"
            name="name"
            label="Package Name"
            value={packageData.name || ''}
            onChange={handleInputChange}
            helperText="Give your package a memorable name"
            placeholder="Romantic Dinner for Two"
          />
        </Grid>
        
        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel id="packageType-label">Package Type</InputLabel>
            <Select
              labelId="packageType-label"
              id="packageType"
              name="packageType"
              value={packageData.packageType || 'dinner'}
              onChange={handleSelectChange}
            >
              <MenuItem value="dinner">Dinner</MenuItem>
              <MenuItem value="experience">Experience</MenuItem>
              <MenuItem value="event">Event</MenuItem>
              <MenuItem value="special">Special Occasion</MenuItem>
            </Select>
            <FormHelperText>Select the type of package you're offering</FormHelperText>
          </FormControl>
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            id="description"
            name="description"
            label="Description"
            multiline
            rows={4}
            value={packageData.description || ''}
            onChange={handleInputChange}
            helperText="Describe what makes this package special"
            placeholder="A cozy dinner for two featuring our chef's specialties and a complimentary glass of wine..."
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="maxCapacity"
            name="maxCapacity"
            label="Maximum Capacity"
            type="number"
            inputProps={{ min: 1 }}
            value={packageData.maxCapacity || 2}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              onChange({ maxCapacity: value > 0 ? value : 1 });
            }}
            helperText="How many guests can this package accommodate?"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PackageBasicInfoForm;
